{
  "consignes.agent.chargement": "Lecture du rôle d’agent…",
  "consignes.agent.depot": "dépose",
  "consignes.agent.deterministe": "Rôle déterministe : aucune consigne : rôle sans modèle.",
  "consignes.agent.droit": "droit",
  "consignes.agent.legende": "Consignes du rôle d’agent : version, statut, rôle du modèle, preuve, service",
  "consignes.agent.sansConsigne": "Aucune consigne publiée pour ce rôle d’agent",
  "consignes.agent.versListe": "Tous les agents de la plateforme",
  "consignes.agentDepot.architecte": "ADR, contraintes pour les agents développeurs",
  "consignes.agentDepot.designer": "maquettes versionnées",
  "consignes.agentDepot.eclaireuse": "dossier de contexte",
  "consignes.agentDepot.garde": "verdicts motivés",
  "consignes.agentDepot.greffiere": "dossier de preuves, commits",
  "consignes.agentDepot.livreuse": "déploiement, reçu",
  "consignes.agentDepot.ouvriere": "diff",
  "consignes.agentDepot.reine": "plan, registre",
  "consignes.agentDepot.reparatrice": "diff de correction",
  "consignes.agentDepot.verificatriceConception": "cas de test",
  "consignes.agentDepot.verificatriceExecution": "exécutions, preuves",
  "consignes.agentDroit.architecte": "lecture ; écriture d’ADR",
  "consignes.agentDroit.designer": "lecture ; écriture de maquettes",
  "consignes.agentDroit.eclaireuse": "lecture seule",
  "consignes.agentDroit.garde": "lecture seule",
  "consignes.agentDroit.greffiere": "écriture git (un seul committeur) ; écriture des liens",
  "consignes.agentDroit.livreuse": "déploiement hors production ; la production exige l’approbation humaine",
  "consignes.agentDroit.ouvriere": "écriture dans l’espace de travail uniquement",
  "consignes.agentDroit.reine": "lecture de tout ; écriture des registres et des affectations",
  "consignes.agentDroit.reparatrice": "écriture dans l’espace de travail",
  "consignes.agentDroit.verificatriceConception": "lecture ; écriture de tests",
  "consignes.agentDroit.verificatriceExecution": "exécution en bac à sable, pas d’écriture de code",
  "consignes.agentRole.architecte": "propose des options techniques, fait décider, trace la décision",
  "consignes.agentRole.designer": "propose parcours d’écrans, maquettes, charte",
  "consignes.agentRole.eclaireuse": "rassemble le contexte : carte du dépôt, spécification, décisions, historique",
  "consignes.agentRole.garde": "juge : revue de code (autre famille de modèle), menaces, conformité, contrôle qualité de la spécification",
  "consignes.agentRole.greffiere": "tient le dossier de preuves, relie exigence, test, anomalie et commit ; seule à committer",
  "consignes.agentRole.livreuse": "construit l’image, déploie en prévisualisation, revient en arrière",
  "consignes.agentRole.ouvriere": "écrit le code d’une fonctionnalité",
  "consignes.agentRole.reine": "décompose la mission en graphe de tâches, tient les registres, route, replanifie, escalade",
  "consignes.agentRole.reparatrice": "corrige une anomalie : test de reproduction d’abord, diff ciblé",
  "consignes.agentRole.verificatriceConception": "écrit les tests d’une exigence, cachés aux agents développeurs",
  "consignes.agentRole.verificatriceExecution": "exécute tests, démarrage et parcours navigateur dans le bac à sable",
  "consignes.agents.avecModele": "avec modèle",
  "consignes.agents.chargement": "Lecture des agents de la plateforme…",
  "consignes.agents.deterministe": "déterministe",
  "consignes.agents.legende": "Rôles d’agent : rôle, déterminisme, consignes en service et preuve de qualification",
  "consignes.agents.sansCatalogue": "Aucun catalogue publié — les rôles d’agent sont listés sans leurs consignes. Démarrez le worker sur l’hôte GPU.",
  "consignes.agents.titre": "Agents de la plateforme",
  "consignes.agents.vide": "Aucun rôle d’agent déclaré",
  "consignes.ancien": "Ce catalogue a été publié il y a {{age}} : le worker ne le republie plus. Les consignes et leur qualification peuvent avoir changé depuis.",
  "consignes.caste.architecte": "agent architecte",
  "consignes.caste.designer": "agent de conception",
  "consignes.caste.eclaireuse": "agent de contexte",
  "consignes.caste.garde": "agent relecteur",
  "consignes.caste.greffiere": "agent de suivi du dossier",
  "consignes.caste.livreuse": "agent de livraison",
  "consignes.caste.ouvriere": "agent développeur",
  "consignes.caste.reine": "agent planificateur",
  "consignes.caste.reparatrice": "agent réparateur",
  "consignes.caste.verificatriceConception": "agent vérificateur (conception des tests)",
  "consignes.caste.verificatriceExecution": "agent vérificateur (exécution des tests)",
  "consignes.changement.ajoute": "ajouté",
  "consignes.changement.inchange": "inchangé",
  "consignes.changement.modifie": "modifié",
  "consignes.changement.retire": "retiré",
  "consignes.choix.a": "À la version",
  "consignes.choix.aucune": "— choisir —",
  "consignes.choix.comparer": "Comparer",
  "consignes.choix.de": "De la version",
  "consignes.choix.indice": "Choisissez les deux versions à comparer.",
  "consignes.col.action": "action",
  "consignes.col.chemin": "chemin",
  "consignes.col.confiance": "base de confiance",
  "consignes.col.consigne": "consigne",
  "consignes.col.consignes": "consignes en service",
  "consignes.col.date": "date",
  "consignes.col.demandeur": "demandée par",
  "consignes.col.empreinte": "empreinte",
  "consignes.col.erreur": "erreur",
  "consignes.col.essai": "essai",
  "consignes.col.etat": "état",
  "consignes.col.fichiers": "fichiers",
  "consignes.col.modele": "modèle",
  "consignes.col.nature": "nature",
  "consignes.col.nom": "nom",
  "consignes.col.origine": "origine",
  "consignes.col.preuve": "preuve",
  "consignes.col.provenance": "fichier:ligne",
  "consignes.col.publie": "publié",
  "consignes.col.role": "rôle",
  "consignes.col.roleAgent": "rôle d’agent",
  "consignes.col.roleModele": "rôle du modèle → modèle",
  "consignes.col.score": "score",
  "consignes.col.service": "service",
  "consignes.col.statut": "statut",
  "consignes.col.taille": "taille",
  "consignes.col.verdict": "verdict",
  "consignes.col.version": "version",
  "consignes.comparer.aucune": "Aucune différence entre ces deux versions.",
  "consignes.comparer.bloc": "{{chemin}}, lignes {{de}} à {{a}}",
  "consignes.comparer.chargement": "Lecture de la différence…",
  "consignes.comparer.composantes": "Composantes du sujet de qualification touchées",
  "consignes.comparer.fonctionnelSeul": "Aucun fichier brut de la version ne diffère, mais le sujet de qualification change (texte résolu ou graphe d’inclusion) : voir ci-dessous.",
  "consignes.comparer.fragment": "Le fragment partagé a changé : la preuve de qualification des consignes qui l’incluent serait périmée.",
  "consignes.comparer.inchanges": "Fichiers inchangés ({{n}})",
  "consignes.comparer.inverser": "Inverser",
  "consignes.comparer.lignes": "{{plus}} ligne(s) ajoutée(s), {{moins}} retirée(s)",
  "consignes.comparer.manquant": "Différence indisponible : contenu cité par le catalogue mais non stocké.",
  "consignes.comparer.nonPublie": "Différence indisponible : fichier non publié (plus de 1 Mio, non UTF-8 ou exclu).",
  "consignes.comparer.sens": "de {{de}} ({{oDe}}) à {{a}} ({{oA}})",
  "consignes.comparer.titre": "Comparer deux versions de {{nom}}",
  "consignes.comparer.tropGrand": "Fichier trop long pour une comparaison ligne à ligne (plus de 20 000 lignes, ou distance d’édition au-delà de 2 000).",
  "consignes.composante.carte": "paramètres de la consigne (hors cycle de vie)",
  "consignes.composante.inclusions": "graphe d’inclusion",
  "consignes.composante.injection": "cas d’injection",
  "consignes.composante.reference": "cas de référence",
  "consignes.composante.schemaEntree": "schéma d’entrée",
  "consignes.composante.schemaSortie": "schéma de sortie",
  "consignes.composante.systeme": "texte système servi (system.md résolu)",
  "consignes.composante.tache": "texte de tâche servi (task.md résolu)",
  "consignes.confiance.dans": "dans la base de confiance",
  "consignes.confiance.hors": "hors base de confiance",
  "consignes.correlation.autrePublication": "La qualification vient d’une autre publication (un autre cycle du worker) : elle n’est pas rapportée au texte affiché.",
  "consignes.correlation.autreWorker": "La qualification vient d’une autre publication (un autre worker) : elle n’est pas rapportée au texte affiché.",
  "consignes.correlation.registreAbsent": "Aucun instantané du registre des consignes ne cite cette consigne : sa qualification n’est pas connue.",
  "consignes.correlation.texteChange": "Le texte servi a changé depuis la qualification, à version constante : la preuve de qualification ne correspond plus au texte affiché.",
  "consignes.demande.approuvee": "approuvée",
  "consignes.demande.attente": "en attente d’approbation",
  "consignes.demande.refusee": "refusée",
  "consignes.demande.retiree": "retirée",
  "consignes.demandes.legende": "Demandes de promotion de la consigne",
  "consignes.demandes.versRegistre": "Promouvoir : depuis le registre des consignes",
  "consignes.demandes.vide": "Aucune demande de promotion pour cette consigne",
  "consignes.divergence": "Le catalogue a été republié pendant la lecture : ce contenu ne correspond pas à la publication affichée. Il n’est pas montré.",
  "consignes.e0.absent": "Catalogue des consignes non publié : le texte, les versions et les textes hors cartes apparaîtront quand le worker le publiera.",
  "consignes.e0.admissibilite": "Admissibilité calculée, pas un usage observé.",
  "consignes.e0.chargement": "Lecture du catalogue des consignes…",
  "consignes.e0.erreur": "Le catalogue des consignes n’a pas pu être lu ; le registre ci-dessous reste affiché.",
  "consignes.e0.inconnu": "inconnu ({{n}} consigne(s) d’admissibilité inconnue)",
  "consignes.e0.refus": "Le catalogue des consignes est réservé à l’administration de la plateforme.",
  "consignes.e0.sansPreuve": "Consignes servies sans preuve de qualification :",
  "consignes.e0.usage": "Usage servi par le worker : {{usage}}.",
  "consignes.erreur": "Le catalogue des consignes n’a pas pu être lu.",
  "consignes.etatTexte.absent": "absent du fichier",
  "consignes.etatTexte.illisible": "illisible",
  "consignes.etatTexte.nonLitteral": "non littéral",
  "consignes.etatTexte.nonPubliable": "non publiable",
  "consignes.etatTexte.tropGrand": "trop grand",
  "consignes.etatTexte.trouve": "trouvé",
  "consignes.famille.coeurIa": "Prompts de core-ia",
  "consignes.famille.intention": "Constantes d’intention",
  "consignes.famille.partage": "Fragment partagé",
  "consignes.famille.piles": "Règles de pile",
  "consignes.fiche.admissibilite": "L’état de service est une admissibilité calculée d’après la règle du worker, pas un usage observé.",
  "consignes.fiche.appelants": "appelée par",
  "consignes.fiche.basculeBrut": "Texte brut (sans inclusions développées)",
  "consignes.fiche.chargement": "Lecture de la consigne…",
  "consignes.fiche.chargementVersion": "Lecture de la version courante…",
  "consignes.fiche.etiquetteResolu": "{{nom}} (résolu)",
  "consignes.fiche.inclusions": "Inclusions : {{liste}}",
  "consignes.fiche.legendeVersions": "Versions de la consigne, origine, fichiers et taille",
  "consignes.fiche.onglets": "Sections de la consigne",
  "consignes.fiche.parametresVide": "Aucun fichier de paramètres dans la version courante",
  "consignes.fiche.resoluErreur": "Le texte résolu n’est pas publié ({{code}}) : le texte brut est affiché.",
  "consignes.fiche.roleAgent": "rôle d’agent",
  "consignes.fiche.sansFichier": "Aucun fichier {{nom}} dans cette version.",
  "consignes.fiche.schemasVide": "Aucun schéma dans la version courante",
  "consignes.fiche.suitesVide": "Aucune suite de cas dans la version courante",
  "consignes.fiche.version": "version {{v}}",
  "consignes.fiche.versionsVide": "Aucune version publiée pour cette consigne",
  "consignes.filAriane": "Retour",
  "consignes.fonctionnel.inconnu": "octets modifiés (sujet normalisé non recalculé)",
  "consignes.fonctionnel.non": "octets modifiés, texte servi identique",
  "consignes.fonctionnel.oui": "le texte servi change",
  "consignes.introuvable.agent": "Ce rôle d’agent n’existe pas dans le catalogue publié.",
  "consignes.introuvable.consigne": "Cette consigne n’existe pas dans le catalogue publié.",
  "consignes.introuvable.fichier": "Ce fichier n’existe pas dans la version publiée.",
  "consignes.introuvable.texte": "Ce texte n’existe pas dans le catalogue publié.",
  "consignes.introuvable.version": "Cette version n’existe pas dans le catalogue publié.",
  "consignes.lecteur.chargement": "Lecture du contenu…",
  "consignes.lecteur.erreurLecture": "Ce contenu n’a pas pu être lu.",
  "consignes.lecteur.manquant": "Le catalogue cite ce contenu mais ne le stocke pas encore : le worker le publiera au prochain cycle.",
  "consignes.lecteur.nonPublie": "Ce contenu n’est pas publié (trop grand, non UTF-8, exclu ou non résolu).",
  "consignes.nature.autre": "autre",
  "consignes.nature.carte": "paramètres",
  "consignes.nature.journal": "journal des changements",
  "consignes.nature.partage": "fragment partagé",
  "consignes.nature.schema": "schéma",
  "consignes.nature.suite": "suite de cas",
  "consignes.nature.texte": "texte",
  "consignes.nonPublie.exclu": "Fichier non publié : exclu de la publication ({{code}}).",
  "consignes.nonPublie.nonUtf8": "Fichier non publié : contenu non UTF-8, métadonnées seules.",
  "consignes.nonPublie.tropGrand": "Fichier non publié : plus de 1 Mio, métadonnées seules.",
  "consignes.onglet.demandes": "Demandes",
  "consignes.onglet.parametres": "Paramètres",
  "consignes.onglet.qualification": "Qualification",
  "consignes.onglet.schemas": "Schémas",
  "consignes.onglet.suites": "Suites",
  "consignes.onglet.texte": "Texte",
  "consignes.onglet.versions": "Versions",
  "consignes.origine.courante": "courante",
  "consignes.origine.instantane": "instantané",
  "consignes.origineInvalide": "Adresse invalide : l’origine d’une version est « current » (courante) ou « snapshot » (instantané).",
  "consignes.parametreManquant": "Adresse incomplète : l’objet à afficher n’est pas précisé",
  "consignes.parametreManquantIndice": "Ouvrez-le depuis le registre des consignes.",
  "consignes.preuve.absente": "jamais qualifiée",
  "consignes.preuve.perimee": "preuve de qualification périmée",
  "consignes.preuve.valide": "preuve de qualification valide",
  "consignes.publication": "Catalogue publié par {{worker}} il y a {{age}} ({{quand}}), révision {{rev}}, usage servi {{usage}}.",
  "consignes.qualif.le": "qualifiée le {{quand}}",
  "consignes.qualif.legende": "Rapports de qualification : essai, date, modèle, score, verdict",
  "consignes.qualif.limite": "La qualification est rapportée au texte affiché par les empreintes des textes résolus ; schémas et suites entrent au sujet sous forme normalisée, non comparée ici.",
  "consignes.qualif.modele": "rôle du modèle → modèle",
  "consignes.qualif.promouvable": "promouvable",
  "consignes.qualif.refuse": "refusé",
  "consignes.qualif.repli": "repli {{modele}}",
  "consignes.qualif.sansRapport": "Aucun rapport de qualification pour cette version.",
  "consignes.qualif.suites": "suites",
  "consignes.qualif.suitesValeur": "{{reference}} cas de référence, {{injection}} cas d’injection",
  "consignes.refus": "Consignes et rôles d’agent : accès réservé à l’administration de la plateforme.",
  "consignes.relire": "Relire l’écran",
  "consignes.resume.ajoutes": "{{n}} ajouté(s)",
  "consignes.resume.inchanges": "{{n}} inchangé(s)",
  "consignes.resume.modifies": "{{n}} modifié(s)",
  "consignes.resume.retires": "{{n}} retiré(s)",
  "consignes.retour": "← Consignes et rôles d’agent",
  "consignes.retourRegistre": "Revenir au registre des consignes",
  "consignes.roleModele.code": "code (principal)",
  "consignes.roleModele.general": "généraliste",
  "consignes.roleModele.independant": "relecteur indépendant",
  "consignes.roleModele.raisonnement": "relecteur de raisonnement",
  "consignes.roleModele.rapide": "utilitaire rapide",
  "consignes.sansContenu.absent": "Ce nom n’est plus dans le fichier : l’inventaire déclaré a dérivé. Aucun contenu n’est publié.",
  "consignes.sansContenu.autre": "Aucun contenu publié pour ce texte (état : {{etat}}).",
  "consignes.sansContenu.nonLitteral": "Cette expression n’est pas un texte littéral (f-chaîne, appel, attribut) : aucun contenu n’est publié.",
  "consignes.service.avecPreuve": "servie avec preuve de qualification",
  "consignes.service.inconnu": "admissibilité inconnue",
  "consignes.service.refusee": "refusée par le worker",
  "consignes.service.sansAppelant": "aucun appelant",
  "consignes.service.sansPreuve": "servie sans preuve de qualification",
  "consignes.statut.active": "active",
  "consignes.statut.candidate": "en essai",
  "consignes.statut.deprecated": "dépréciée",
  "consignes.statut.draft": "brouillon",
  "consignes.texte.chargement": "Lecture du texte…",
  "consignes.texte.etiquette": "Contenu de {{nom}}",
  "consignes.texte.famille": "famille",
  "consignes.texte.provenance": "provenance",
  "consignes.texte.versListe": "Tous les textes hors cartes",
  "consignes.textes.chargement": "Lecture des textes hors cartes…",
  "consignes.textes.intro": "Textes envoyés au modèle hors des consignes d’agent : constantes d’intention, règles de pile, prompts de core-ia et fragment partagé. Lecture seule.",
  "consignes.textes.legende": "Textes de la famille : fichier et ligne, nom, état, base de confiance",
  "consignes.textes.limite": "Limite : un texte écrit en ligne dans une fonction, et non en constante nommée, n’est pas inventorié ici ; l’inventaire complet des textes envoyés au modèle relève d’un paquet suivant.",
  "consignes.textes.ouvrir": "Ouvrir",
  "consignes.textes.ouvrirNom": "Ouvrir {{nom}}",
  "consignes.textes.titre": "Textes hors cartes",
  "consignes.textes.vide": "Aucun texte hors cartes dans le catalogue publié",
  "consignes.unite.kio": "{{n}} Kio",
  "consignes.unite.mio": "{{n}} Mio",
  "consignes.unite.octets": "{{n}} o",
  "consignes.versAgents": "Agents de la plateforme",
  "consignes.versTextes": "Textes hors cartes ({{n}})",
  "consignes.version.chargement": "Lecture de la version…",
  "consignes.version.choisir": "Choisissez un fichier pour le lire.",
  "consignes.version.comparerCourante": "Comparer avec la version courante",
  "consignes.version.fichierAbsent": "Ce fichier n’existe pas dans cette version.",
  "consignes.version.legende": "Fichiers de la version : chemin, nature, empreinte, publication",
  "consignes.version.publie": "oui",
  "consignes.version.resoluNonPublie": "{{nom}} résolu : non publié ({{code}})",
  "consignes.version.resoluPublie": "{{nom}} résolu : publié",
  "consignes.version.sansFichier": "Cette version est publiée sans fichier ({{code}}).",
  "consignes.version.titre": "{{nom}} — version {{v}}",
  "consignes.vide": "Aucun catalogue publié — démarrez le worker sur l’hôte GPU",
  "consignes.videIndice": "Le worker publie le catalogue des consignes à son démarrage, puis toutes les 5 minutes.",
  "consignes.voirConsigne": "Voir la consigne"
}
